export default async (promise)=> {
    try {
        const resp = await promise;
        return [false, resp];
    } catch(e) {     
        return [e, undefined];
    }
}


// WEBPACK FOOTER //
// ./src/common/awaitHandler.js